const fr = {
    estateSearch: {
        loading: 'Les propriétés sont en cours de chargement ...',
        search: 'Rechercher',
        emptyFilter: 'Filtre vide',
        noResults: 'Désolé, nous n\'avons trouvé aucun résultat pour votre recherche.',
        noResultsCTA: 'Niet gevonden wat je zocht?',
        noResultsCTADescription: 'Schrijf je in en ontvang nieuwe panden die met uw zoekcriteria overeenkomen via e-mail',
        noResultsCTAButton: 'Enregistrer',
        cheapestFirst: 'Prix le moins cher en premier',
        mostExpensiveFirst: 'Prix le plus cher en premier',
        oldestFirst: 'Le plus ancien en premier',
        newestFirst: 'Le plus récent d\'abord',
        result: 'résultat',
        results: 'résultats',
        showMap: 'montrer la carte',
        hideMap: 'cacher la carte',
        found: 'trouvé',
        sortBy: 'Trier sur',
        selected: 'choisi',
    },
};

export { fr };
